import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const getPromoactionMaxUsageCountText = (promoaction: DeepPartial<PromoactionModel>): string => {
    const maxUsageLimit = promoaction.validity?.maxUsageLimit;

    return maxUsageLimit === 'true' ? 'Ограничить: 1 раз' : 'Без ограничений';
};
